import {
  Button,
  Menu,
  MenuItem,
  ThemeProvider,
  createTheme,
} from '@mui/material';
import { useState } from 'react';

const SortArray = [
  { label: 'Name A-Z', value: 'asc' },
  { label: 'Name Z-A', value: 'desc' },
];
const getSortLabel = (id) => {
  const temp = SortArray?.filter((it) => it?.value === id);
  return temp[0]?.label;
};

const FilterBy = (props) => {
  const [sortByVal, setSortByVal] = useState(
    props?.value !== null && props?.value !== undefined
      ? getSortLabel(props.value)
      : 'Name A-Z'
  );
  const [sortByEl, setsortByEl] = useState(null);
  const dropdownopen = Boolean(sortByEl);
  const handleDropdownClick = (event) => {
    setsortByEl(event.currentTarget);
  };
  const handleDropdownChange = (ans) => {
    props.handleSortBy(ans);
    setSortByVal(ans);
    setsortByEl(null);
  };
  return (
    <div
      className={`select_opt relative bottom-[2px] pl-[20px] right-[20px] cursor-pointer shrink-0`}
    >
      <img
        src='/images/select_icon2.svg'
        alt='arrow'
        className='absolute top-[11px] left-[22px]'
      />
      <img
        src='/images/select_icon1.svg'
        alt='arrow'
        className='absolute top-[15px] right-[2px]'
      />
      <Button
        id='sortby-button'
        aria-controls={dropdownopen ? 'basic-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={dropdownopen ? 'true' : undefined}
        onClick={handleDropdownClick}
      >
        {sortByVal}
      </Button>
      <ThemeProvider theme={createTheme()}>
        <Menu
          id='sortby-menu'
          anchorEl={sortByEl}
          open={dropdownopen}
          onClose={() => setsortByEl(null)}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
          defaultValue={'Name Z-A'}
        >
          {SortArray.map((item, idx) => {
            return (
              <MenuItem
                key={item?.value}
                onClick={() => handleDropdownChange(item?.label)}
              >
                {item?.label}
              </MenuItem>
            );
          })}
        </Menu>
      </ThemeProvider>
    </div>
  );
};

export default FilterBy;
